module.exports = __webpack_public_path__ + "media/components/theme/fonts/CooperHewitt-Bold-1ca8a3a1acfc71401b8253564048487d.ttf";